/**
 * LogoutHandler - Handles automatic logout events with toast and redirect
 * This component listens for auth:logout events and shows toast message,
 * then redirects to login page
 */

import { useEffect } from 'react';
import { useToast } from '../Toast/Toast';
import { tokenManager } from '../../services/api';

const LogoutHandler = () => {
  const toast = useToast();

  useEffect(() => {
    const handleLogout = (event) => {
      const errorMessage = event.detail?.message || 'Your session has expired. Please login again.';

      // Show error toast with the message from API response
      toast.error(errorMessage, {
        duration: 5000,
      });

      // Clear auth data (in case it wasn't cleared already)
      tokenManager.clearAll();

      // Redirect to login page after a short delay to allow toast to be visible
      setTimeout(() => {
        window.location.href = '/login';
      }, 500);
    };

    window.addEventListener('auth:logout', handleLogout);
    return () => {
      window.removeEventListener('auth:logout', handleLogout);
    };
  }, [toast]);

  // This component doesn't render anything
  return null;
};

export default LogoutHandler;

